import { useMutation } from '@tanstack/react-query';

import { api } from './client-api';

export interface SatisfactionSurveyBody {
  comment?: string;
  userRole: 'admin' | 'agent' | 'buyer' | 'centra-user' | 'viewer';
  rating: string;
}

export const useSatisfactionSurvey = () => {
  return useMutation({
    mutationFn: async (data: SatisfactionSurveyBody) => {
      const response = await api.post('/survey', data);

      return response.data;
    },
  });
};
